import { RootState } from "@/store/reducers";
import { useSelector } from "react-redux";

const usePermission = () => {
  const permissions = useSelector(
    (state: RootState) => state.login.permissions
  );

  const hasPermission = (menuName: string) => {
    return permissions.some((s) => s.name == menuName && s.showMenu);
  };

  return {
    showArticle: hasPermission("Articles"),
    showPost: hasPermission("Posts"),
    showEvent: hasPermission("Events"),
    showFriend: hasPermission("Friends"),
  };
};

export default usePermission;
